module.exports = __webpack_public_path__ + "img/generator_wind.f479ceac.svg";